import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "creationV2__body" }
const _hoisted_2 = { class: "creationV2__scroll-wrapper" }
const _hoisted_3 = { class: "creationV2__container" }
const _hoisted_4 = { class: "flex flex-col gap-2 lg:gap-[calc(8px+0.2vw)]" }
const _hoisted_5 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }
const _hoisted_6 = { class: "flex flex-col gap-2 lg:gap-[calc(8px+0.3vw)]" }
const _hoisted_7 = { class: "flex lg:gap-[calc(6px+0.1vw)]" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#star-custom" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "creation__text-small text-creation-on-background/creation-high font-semibold whitespace-nowrap" }
const _hoisted_12 = { class: "font-normal" }
const _hoisted_13 = { class: "inline-flex self-end justify-end sticky bottom-0" }
const _hoisted_14 = {
  key: 0,
  class: "button button--circle-creation opacity-0 pointer-events-none"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon stroke-2" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#arrow-right" })
], -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          appear: "",
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.agentMessage), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          appear: "",
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (i) => {
                  return _createElementVNode("div", {
                    key: i,
                    class: "cursor-pointer select-none"
                  }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.setRating(i)),
                      class: "group relative flex justify-center"
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["icon w-10 h-10 lg:w-[calc(40px+1.5vw)] lg:h-[calc(40px+1.5vw)] transition group-hover:scale-110", { 'text-creation-on-background': this.isStarSelected(i), 'text-creation-on-background/creation-low': !this.isStarSelected(i) }])
                      }, _hoisted_10, 2))
                    ], 8, _hoisted_8)
                  ])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.rating === undefined)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('creation.CSATCTALabel')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.getRatingTitle) + " ", 1),
                      _createElementVNode("span", _hoisted_12, "(" + _toDisplayString(_ctx.rating) + ")", 1)
                    ], 64))
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          (!_ctx.showContinueButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14))
            : _createCommentVNode("", true),
          _createVNode(_Transition, {
            name: "custom-classes",
            "enter-active-class": "animate__fadeInUp",
            "leave-active-class": "animate__fadeOutDown"
          }, {
            default: _withCtx(() => [
              (_ctx.showContinueButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    class: "button button--circle-creation button--circle-creation-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.next())),
                    tabindex: "5"
                  }, _hoisted_16))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}